enum Gender {
  FEMALE = 'Female',
  MALE = 'Male',
  UNKNOWN = 'Unknown',
}
export default Gender
